import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flight-landing"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10.2802 2.5L12.212 3.01764L14.7779 11.9874L20.2837 13.4626C21.0839 13.6771 21.5587 14.4996 21.3443 15.2998C21.1299 16.1 20.3074 16.5748 19.5072 16.3604L2.60352 11.8311L2.93169 6.74264L4.38057 7.13087L5.02205 9.3733L10.1415 10.745L10.2802 2.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.2802 2.5L12.212 3.01764L14.7779 11.9874L20.2837 13.4626C21.0839 13.6771 21.5587 14.4996 21.3443 15.2998C21.1299 16.1 20.3074 16.5748 19.5072 16.3604L2.60352 11.8311L2.93169 6.74264L4.38057 7.13087L5.02205 9.3733L10.1415 10.745L10.2802 2.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 20H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FlightLanding = Vue.extend<IconProps>({
  name: 'FlightLandingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'flight-landing',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FlightLanding;
